import axios from 'axios';

export default {

    //Permet de récuperer la liste des challenges d'un utilisateur
    get(userId, length = 5, startIndex = 0) {
        let params = '?length=' + length;
        if(startIndex != null){
            params = params + '&start_index=' + startIndex;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/data' + params);
    },

    //Permet de récuperer les details d'un challenge
    getDetails(userId, challengeId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/' + challengeId + '/data');
    },

    getCommercialsChallenges(userId, length = 5, startIndex = 0){
        let params = '?length=' + length;
        if(startIndex != null){
            params = params + '&start_index=' + startIndex;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/data/commercials' + params);
    },

    //Permet d'ajouter un nouveau challenge
    post(userId, challengeData) {
        return axios.post(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/add', challengeData);
    },

    //Permet de modifier un challenge existant
    patch(userId, challengeId, challengeData) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/edit/' + challengeId, challengeData);
    },

    //Permet de supprimer un challenge
    delete(userId, challengeId) {
        return axios.delete(process.env.VUE_APP_API_URI + '/api/challenges/' + userId + '/delete/' + challengeId);
    },
}
